var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-modal" }, [
    _c("div", {
      staticClass: "custom-modal__background",
      on: {
        click: function () {
          return _vm.close()
        },
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "custom-modal__inner" }, [
      _c(
        "div",
        { ref: "modalHeader", staticClass: "custom-modal__header" },
        [
          _vm._t("modalHeader"),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-close",
            on: {
              click: function () {
                return _vm.close()
              },
            },
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "modalBody",
          staticClass: "custom-modal__body",
          style: _vm.modalBodyStyle,
        },
        [_vm._t("modalBody")],
        2
      ),
      _vm._v(" "),
      _vm.hasFooter
        ? _c(
            "div",
            { staticClass: "custom-modal__footer" },
            [
              _vm._t("modalFooter"),
              _vm._v(" "),
              this.$props.printButton
                ? _c(
                    "button",
                    { staticClass: "uk-button", on: { click: _vm.print } },
                    [
                      _c("i", { staticClass: "uk-icon-print" }),
                      _vm._v("\n                Распечатать\n            "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$props.downloadButton
                ? _c(
                    "button",
                    {
                      staticClass: "uk-button uk-button-primary",
                      on: { click: _vm.getPdf },
                    },
                    [
                      _c("i", { staticClass: "uk-icon-file-pdf-o" }),
                      _vm._v("\n                Сохранить PDF\n            "),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }